import type { ErrorCodeMapping } from 'helpers/actionCreator';

const errorMapping: ErrorCodeMapping = {
  CANNOT_SKIP_STREAMLABS_ALERTS: 'alert:errors.cannotSkipStreamlabsAlerts',
  INSUFFICIENT_PERMISSIONS: 'errors:asyncValidation.insufficientPermissions',
};

export default errorMapping;
